export default __webpack_public_path__ + "static/lutein-first-aid-header-1c3268e56c709d8d642e432decabd594.jpg";